"use client";

import React from "react";
import { Cpu, MonitorSmartphone, Wrench, Headphones } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Facelift BTX",
  description: "Our signature rejuvenation treatment designed to smooth fine lines and restore youthful definition with precision. — FROM £195",
  icon: Cpu
}, {
  title: "Anti-Sweating Injections",
  description: "A specialized therapeutic solution providing long-lasting confidence and comfort for targeted areas. — FROM £249",
  icon: MonitorSmartphone
}, {
  title: "Neuro Lift\xA0",
  description: "A non-invasive facial treatment designed to stimulate and tone the facial muscles, helping to lift, firm and improve facial contours for a more refreshed, youthful appearance. - FROM £119",
  icon: Wrench
}, {
  title: "OxyGen+ Facial",
  description: "The ultimate high-end oxygenating treatment for instant hydration and a luminous, camera-ready glow. — FROM £89",
  icon: Headphones
}];
export default function CustomerServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="146928" id="servicesmenu" className="py-16 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-ring)_0%,_transparent_70%)] opacity-[0.05] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-medium font-serif text-center mb-16 text-foreground tracking-tight">Specialist Treatments</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, i) => <Card key={i} data-index={i} className="bg-card/40 backdrop-blur-sm border-border/40 text-card-foreground flex flex-col h-full transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-ring/5 rounded-3xl group">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-500">
                    <service.icon className="w-5 h-5 text-ring/80" />
                  </div>
                  <CardTitle className="font-serif italic text-2xl tracking-wide text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <p className="font-sans text-sm text-muted-foreground leading-relaxed tracking-normal">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-0 mt-auto">
                  <Button asChild className="w-full rounded-lg bg-transparent text-foreground hover:bg-primary/10 border-2 border-primary/40 transition-all duration-500 group-hover:border-primary">
                    <Link to="tel:07766733976">Book Appointment</Link>
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}